<template>
   <main class="main reg-page login-page">
    <div class="main-wrapper">
        <div class="container">
          <div class="center">
            <div class="left-up">
              <div @click="$parent.closeSignInModal" class="desc back">
                  {{ $t('Back to mainpage') }}
              </div>
              <div class="form">
                <div class="tabs">
                  <router-link to="/login" class="title regular" v-text="$t('LOGIN')" />
                  <router-link to="/register" class="title regular" v-text="$t('SIGN UP')" />
                </div>
                <div class="form-wrapper">
                  <div class="form-fields login-content">
                    <div class="form-fields-wrapper">
                      <label>
                        <div class="desc">*{{ $t('Name') }}</div>
                        <input type="text" :placeholder="$t('Name')" v-model="name"/>
                      </label>
                      <label>
                        <div class="desc">*{{ $t('Surname') }}</div>
                        <input type="text" :placeholder="$t('Surname')" v-model="surname"/>
                      </label>
                      <label>
                        <div class="desc">*{{ $t('Phone') }}</div>
                        <input type="number" :placeholder="$t('Phone')" v-model="phone"/>
                      </label>
                      <label>
                        <div class="desc">*{{ $t('Email') }}</div>
                        <input type="email" :placeholder="$t('Email')" v-model="email"/>
                      </label>
                      <label>
                        <div class="desc">*{{ $t('Password') }}</div>
                        <input type="password" :placeholder="$t('Password')" v-model="pass"/>
                      </label>
                      <div class="chekbox-container">
                        <label class="chekbox-label">
                          <div class="chekbox-label-wrapper">
                            <input type="checkbox" name="terms" v-model="terms"/>
                            <div class="checkbox"></div>
                            <span class="title">{{ $t('I agree with') }} </span>
                            <a @click="$parent.goToPage('privacy')" class="title"> {{ $t('privacy policy') }}</a>
                            <span class="title"> {{ $t('and') }} </span>
                            <a @click="$parent.goToPage('terms')" class="title"> {{ $t('terms and conditions') }}</a>
                          </div>
                        </label>
                      </div>
                      <div class="cta-container">
                        <button :class="['button', {'disabled': !requiredRegisterFieldsAreFilled || $parent.registrationInProgress}]" @click="submitRegister">
                          <span><span>[</span> {{ $t('SIGN UP') }} <span>]</span></span>
                        </button>
                      </div>
                      <transition name="slide">
                        <div v-if="$parent.error" class="error-desc desc red">{{$parent.error}}</div>
                      </transition>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
    </main>
  </template>
  
  <script>
  
  export default {
    name: 'Register',
    props: [],
    components: {
    },
    data: function() {
      return {
        email: '',
        pass: '',
        name: '',
        surname: '',
        phone: '',
        terms: false
      }
    },
    computed: {
      requiredRegisterFieldsAreFilled() {
        let fieldsAreFilled;
        if(
          this.name && this.surname  && this.phone && 
          this.email && this.pass 
          && this.terms 
        ) {
          fieldsAreFilled = true;
        } else {
          fieldsAreFilled = false;
        }
        return fieldsAreFilled;
      }
    },
    mounted() {
      
    },
    methods: {
      submitRegister() {
        if (!this.requiredRegisterFieldsAreFilled || this.$parent.registrationInProgress) {
          return;
        }

        let regData = {
          "name": this.name,
          "surname": this.surname,
          "email": this.email,
          "phone": this.phone,
          "password": this.pass
        }
          this.$emit('registration', regData)
      }
    }
  }
  </script>
